/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_HintInputs */

const cs_gallery_hint = /** @type {(inputs: Gallery_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Všechny fotky zde se publikují na portály a veřejný web. Pořadí změníte přetažením — první fotka je hlavní/cover.`)
};

const en_gallery_hint = /** @type {(inputs: Gallery_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All photos here are published to portals and the public site. Drag to reorder — the first photo is the main/cover.`)
};

/**
* | output |
* | --- |
* | "All photos here are published to portals and the public site. Drag to reorder — the first photo is the main/cover." |
*
* @param {Gallery_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gallery_hint = /** @type {((inputs?: Gallery_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gallery_hint(inputs)
	return cs_gallery_hint(inputs)
});